import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import EmendaCard from './EmendaCard';
import Pagination from './Pagination';
import './CardsView.css';

export default function CardsView({ data, columns, onViewDetails, currentPage, totalPages, onPageChange }) {
  if (data.length === 0) {
    return (
      <div className="cards-view-empty">
        <p>Nenhuma emenda encontrada</p>
      </div>
    );
  }

  return (
    <div className="cards-view">
      <div className="cards-view__grid">
        <AnimatePresence>
          {data.map((emenda, index) => {
            // Criar key única baseada nos dados reais
            const uniqueKey = `${Object.values(emenda).slice(0, 3).join('-')}-${index}`;
            
            return (
              <motion.div
                key={uniqueKey}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
              >
                <EmendaCard
                  emenda={emenda}
                  columns={columns}
                  onViewDetails={onViewDetails}
                />
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
